import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog-delete-confirm" }
const _hoisted_2 = { class: "dialog-delete-confirm__title" }
const _hoisted_3 = { class: "dialog-delete-confirm__description" }
const _hoisted_4 = { class: "dialog-delete-confirm__description-name" }
const _hoisted_5 = { class: "dialog-delete-confirm__description-name" }
const _hoisted_6 = { class: "dialog-delete-confirm__actions" }

import AppButton from "@/components/ui-kit/button/AppButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDeleteConfirm',
  props: {
    type: {},
    name: {}
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.type === 'chat' ? 'Удалить чат?' : 'Удалить группу?'), 1),
    _createElementVNode("div", _hoisted_3, [
      (props.type === 'chat')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createTextVNode(" Вы собираетесь удалить чат с пользователем ")),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1),
            _cache[3] || (_cache[3] = _createTextVNode(" без возможности восстановления "))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[4] || (_cache[4] = _createTextVNode(" Вы собираетесь удалить группу ")),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1),
            _cache[5] || (_cache[5] = _createTextVNode(" без возможности восстановления "))
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AppButton, {
        class: "dialog-delete-confirm__actions-button",
        type: "secondary",
        label: "Отмена",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }),
      _createVNode(AppButton, {
        class: "dialog-delete-confirm__actions-button",
        label: "Подтвердить",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      })
    ])
  ]))
}
}

})